import React, { Component } from 'react';
import './styles.css';

export default class NotificationsWidget extends Component {
  render() {
    return (
      <div className="notifications__widget">
        NotificationsWidget
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/NotificationsWidget/NotificationsWidget.js